import { render, staticRenderFns } from "./TabComponentThree.vue?vue&type=template&id=0d9010a8&scoped=true"
import script from "./TabComponentThree.vue?vue&type=script&lang=js"
export * from "./TabComponentThree.vue?vue&type=script&lang=js"
import style0 from "./TabComponentThree.vue?vue&type=style&index=0&id=0d9010a8&prod&lang=scss&scoped=true"
import style1 from "./TabComponentThree.vue?vue&type=style&index=1&id=0d9010a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9010a8",
  null
  
)

export default component.exports